var _filter, _clipPath, _clipPath2, _clipPath3, _clipPath4, _clipPath5, _use, _use2, _use3, _use4, _use5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCmetLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "190px",
    height: "31px",
    viewBox: "-40 -10 276 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "alpha",
    filterUnits: "objectBoundingBox",
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    in: "SourceGraphic",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 276,
    height: 31,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.137255,
      stroke: "none"
    }
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 276,
    height: 31
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface5",
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(98.431373%,98.431373%,77.647059%)",
      fillOpacity: 1
    },
    d: "M 7.445312 -0.574219 C 25.003906 -0.574219 42.5625 -0.574219 60.125 -0.574219 C 64 2.898438 68.582031 5.195312 73.867188 6.316406 C 79.152344 5.195312 83.734375 2.898438 87.609375 -0.574219 C 91.425781 -0.574219 95.246094 -0.574219 99.0625 -0.574219 C 100.207031 0.957031 101.351562 0.957031 102.496094 -0.574219 C 132.273438 -0.574219 162.050781 -0.574219 191.824219 -0.574219 C 194.835938 4.210938 194.835938 8.996094 191.824219 13.777344 C 186.863281 14.160156 181.898438 14.542969 176.9375 14.925781 C 176.144531 20.089844 175.378906 25.257812 174.648438 30.425781 C 170.066406 30.425781 165.484375 30.425781 160.90625 30.425781 C 160.070312 25.109375 159.6875 19.75 159.757812 14.351562 C 154.796875 14.351562 149.832031 14.351562 144.871094 14.351562 C 144.625 16.855469 145.578125 18.769531 147.734375 20.09375 C 148.578125 23.644531 148.386719 27.085938 147.160156 30.425781 C 126.929688 30.425781 106.695312 30.425781 86.464844 30.425781 C 85.746094 18.699219 83.839844 18.699219 80.738281 30.425781 C 76.15625 30.425781 71.578125 30.425781 66.996094 30.425781 C 64.097656 18.667969 62.191406 18.667969 61.269531 30.425781 C 42.183594 30.425781 23.09375 30.425781 4.007812 30.425781 C 2.859375 29.066406 1.902344 27.535156 1.144531 25.832031 C 0.382812 19.710938 0.382812 13.585938 1.144531 7.464844 C 2.253906 3.878906 4.351562 1.199219 7.445312 -0.574219 Z M 16.605469 13.203125 C 26.914062 13.203125 37.21875 13.203125 47.527344 13.203125 C 47.527344 14.734375 47.527344 16.265625 47.527344 17.796875 C 36.839844 17.796875 26.148438 17.796875 15.460938 17.796875 C 15.382812 16.121094 15.765625 14.589844 16.605469 13.203125 Z M 16.605469 13.203125 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 276,
    height: 31,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.996078,
      stroke: "none"
    }
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 276,
    height: 31
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface8",
    clipPath: "url(#clip2)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(94.509804%,34.901961%,7.45098%)",
      fillOpacity: 1
    },
    d: "M 55.542969 1.722656 C 62.132812 4.628906 69.003906 6.925781 76.15625 8.609375 C 83.792969 7.257812 91.046875 4.960938 97.917969 1.722656 C 97.917969 9.375 97.917969 17.03125 97.917969 24.683594 C 96.390625 24.683594 94.863281 24.683594 93.335938 24.683594 C 93.527344 19.695312 93.335938 14.71875 92.761719 9.757812 C 82.511719 16.914062 72.011719 17.296875 61.269531 10.90625 C 60.136719 15.4375 59.753906 20.03125 60.125 24.683594 C 58.242188 24.929688 56.523438 24.546875 54.972656 23.535156 C 54.066406 16.171875 54.257812 8.902344 55.542969 1.722656 Z M 55.542969 1.722656 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 276,
    height: 31,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.996078,
      stroke: "none"
    }
  }))), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 276,
    height: 31
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface11",
    clipPath: "url(#clip3)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(94.117647%,32.54902%,4.313725%)",
      fillOpacity: 1
    },
    d: "M 150.597656 1.722656 C 164.339844 1.722656 178.082031 1.722656 191.824219 1.722656 C 191.824219 3.636719 191.824219 5.550781 191.824219 7.464844 C 186.46875 7.273438 181.125 7.464844 175.792969 8.035156 C 175.21875 8.609375 174.648438 9.183594 174.074219 9.757812 C 173.503906 14.71875 173.3125 19.695312 173.503906 24.683594 C 171.59375 24.683594 169.683594 24.683594 167.777344 24.683594 C 167.429688 19.023438 167.8125 13.476562 168.921875 8.035156 C 162.8125 7.65625 156.703125 7.273438 150.597656 6.890625 C 149.191406 5.179688 149.191406 3.457031 150.597656 1.722656 Z M 150.597656 1.722656 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 276,
    height: 31,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.996078,
      stroke: "none"
    }
  }))), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 276,
    height: 31
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface14",
    clipPath: "url(#clip4)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(94.117647%,32.941176%,4.705882%)",
      fillOpacity: 1
    },
    d: "M 112.804688 10.90625 C 122.738281 10.714844 132.664062 10.90625 142.582031 11.480469 C 144.109375 12.628906 144.109375 13.777344 142.582031 14.925781 C 132.664062 15.5 122.738281 15.691406 112.804688 15.5 C 112.804688 13.96875 112.804688 12.4375 112.804688 10.90625 Z M 112.804688 10.90625 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 276,
    height: 31,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.996078,
      stroke: "none"
    }
  }))), _clipPath5 || (_clipPath5 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 276,
    height: 31
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface17",
    clipPath: "url(#clip5)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(94.509804%,35.294118%,7.843137%)",
      fillOpacity: 1
    },
    d: "M 75.011719 17.796875 C 79.035156 18.402344 80.179688 20.507812 78.449219 24.109375 C 72.480469 24.738281 71.335938 22.632812 75.011719 17.796875 Z M 75.011719 17.796875 "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface5",
    mask: "url(#mask0)"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface8",
    mask: "url(#mask1)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(94.117647%,32.54902%,4.313725%)",
      fillOpacity: 1
    },
    d: "M 13.171875 1.722656 C 25.386719 1.722656 37.601562 1.722656 49.816406 1.722656 C 49.816406 3.253906 49.816406 4.785156 49.816406 6.316406 C 37.976562 6.125 26.144531 6.316406 14.316406 6.890625 C 11.261719 11.097656 11.261719 15.308594 14.316406 19.519531 C 25.769531 19.902344 37.21875 20.285156 48.671875 20.667969 C 49.628906 21.828125 50.011719 23.167969 49.816406 24.683594 C 36.78125 25.042969 23.800781 24.660156 10.878906 23.535156 C 9.925781 22.390625 8.972656 21.242188 8.015625 20.09375 C 5.960938 12.613281 7.679688 6.492188 13.171875 1.722656 Z M 13.171875 1.722656 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(94.117647%,32.54902%,4.313725%)",
      fillOpacity: 1
    },
    d: "M 107.078125 1.722656 C 120.058594 1.722656 133.039062 1.722656 146.015625 1.722656 C 146.015625 3.253906 146.015625 4.785156 146.015625 6.316406 C 134.175781 6.125 122.34375 6.316406 110.515625 6.890625 C 107.234375 11.417969 107.613281 15.625 111.660156 19.519531 C 123.105469 20.09375 134.558594 20.285156 146.015625 20.09375 C 146.015625 21.625 146.015625 23.15625 146.015625 24.683594 C 133.03125 24.875 120.050781 24.683594 107.078125 24.109375 C 100.996094 16.570312 100.996094 9.105469 107.078125 1.722656 Z M 107.078125 1.722656 "
  }), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface11",
    mask: "url(#mask2)"
  })), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface14",
    mask: "url(#mask3)"
  })), _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface17",
    mask: "url(#mask4)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCmetLogo);
export default __webpack_public_path__ + "static/media/CMET-logo.9989f1cca71832c331989dad26f68f13.svg";
export { ForwardRef as ReactComponent };